// This file is auto generated!
// Please do not edit manually
// Run 'npm run generate:icons' to regenerate this file.
export const CORPORATE_CHEVRONDOWN = {
    name: 'chevrondown',
    source: `<svg><defs/><symbol id="chevrondown" viewBox="0 0 192 192"><title>chevron-down</title><g id="bd42be74-2b51-484f-8725-90c2cd5798e5" data-name="Chevron_down"><polyline id="c55cef14-6e52-48d5-be84-9c79a9b11263" data-name="&lt;Pfad&gt;" points="164 62 96 130 28 62" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect width="192" height="192" fill="none"/></g></symbol></svg>`,
};
//# sourceMappingURL=chevrondown.js.map